import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

const TOKEN_KEY = "js_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const setToken = (t) => {
    if (t) {
        localStorage.setItem(TOKEN_KEY, t);
        api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
    } else {
        localStorage.removeItem(TOKEN_KEY);
        delete api.defaults.headers.common["Authorization"];
    }
};

if (getToken()) {
    api.defaults.headers.common["Authorization"] = `Bearer ${getToken()}`;
}

export const imgUrl = (u) => {
    if (!u) return "";
    if (u.startsWith("http") || u.startsWith("data:")) return u;
    return `${BACKEND}${u}`;
};
